const initState = {
  successFetching: false,
  errorFetching: false,
  executive: null,
};

export default initState;
